<template>
  <div>
  <vue-date-picker
      :aria-label="` ${field.datahash.label};`"
      auto-apply
      :class="cssClass"
      v-model="date"
      :enableTimePicker="false"
      :is-24="false"
      :min-date="minDate"
      :max-date="maxDate"
      :placeholder="$t('MM/DD/YYYY')"
      :required="required"
      :text-input="{ format: parseDate }"
      :input-class-name="required ? 'datepicker-invalid-error' : ''"
      utc="preserve"
      @open="$emit('open')"
      @closed="$emit('closed')"
  />

  <slot name="error_messages" :anyError="anyError"/>

  <div class="tw-banner-warning" v-if="maxDate && dateDate && maxDate < dateDate">
    <i class="tw-icon exclamation-triangle-white"/>
    Enter a valid date less than {{ moment(maxDate).format(format) }}.
    <span data-invalid class="hidden" />
  </div>

  <div class="tw-banner-warning" v-if="minDate && dateDate && minDate > dateDate">
    <i class="tw-icon exclamation-triangle-white"/>
    Enter a valid date greater than {{moment(minDate).format(format) }}.
    <span data-invalid class="hidden" />
  </div>
  </div>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import moment from 'moment';
const formats = ['MM/DD/YYYY']
const toString = val => moment(val).startOf('day').utc().format()
export {toString}
export default {
  components: { VueDatePicker },
  props: {
    modelValue: {},
    field: {},
    value: {}, // vee-validate
    onlyDate: {type: Boolean, required: false},
    cssClass: {type: String, required: false, default: 'w-64'}
  },
  emits: ['update:modelValue', 'change', 'open', 'closed'],
  data: ()=>({
    moment,
    format: formats[0],
  }),
  computed: {
    date: {
      get(){ return this.modelValue || this.value },
      set(val){
        let localValue;
        if (!val){
          localValue = null
        } else if (this.onlyDate) {
          localValue = moment(val).utc().format().split("T")[0] // getting date in user's time zone
        } else {
          localValue = toString(val)
        }

        this.$emit('update:modelValue', localValue)
        // Temporary hack until we rewrite it properly with Vee-validate
        this.$nextTick().then(()=>{
          // this.$emit('update:modelValue', localValue)
          this.$emit('change', localValue)
        });
      }
    },
    datahash(){ return this.field.datahash || {} },
    minDate(){  return this.getDate('min') },
    maxDate(){ return this.datahash.allow_future_date ? null : this.getDate('max') },
    dateDate(){ return this.date ? new Date(this.date) : null },
    answered(){ return (this.date||'').length > 0 },
    classes(){
      return {
        'ng-valid': this.answered,
        'ng-invalid': this.required
      }
    },
    required(){
      return this.datahash.required && !this.answered
    },
    datesInvalid(){
      if (this.maxDate && this.dateDate && this.maxDate < this.dateDate) return true
      else if (this.minDate && this.dateDate && this.minDate > this.dateDate) return true
      else return false
    },
    anyError(){
      return !!(this.required || this.datesInvalid);
    },
  },
  methods: {
    parseDate(str) { // parsing 2 formats of manual input M/D/YYYY or MM/DD/YYYY
      const match = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (!match) return null;
      const [ , mm, dd, yyyy ] = match;
      const date = new Date(`${yyyy}-${mm.padStart(2,'0')}-${dd.padStart(2,'0')}T00:00:00`);
      return date
    },
    getDate(type){
      const today = new Date();
      const setMinDate = () => new Date('1/1/1900');
      const setMaxDate = () =>
        this.datahash.allow_future_date ? new Date('1/1/2100') : new Date();

      switch (this.datahash.range) {
        case 'absolute':
          return new Date(this.datahash[`${type}Date`]);
        case 'relative':
          if (type === 'min') {
            today.setDate(today.getDate() - this.datahash[`${type}Days`]);
          } else { // it is max, add it
            today.setDate(today.getDate() + this.datahash[`${type}Days`]);
          }
          return today;
        default:
          if (type === 'min') return setMinDate();
          if (type === 'max') return setMaxDate();
      }
    },
    onAnswerChange(){
      this.onUpdate(this.field, 'on_answer_add');
    },
  }
}
</script>
<style scoped>
:deep(.datepicker-invalid-error){
  border-color: rgb(215, 45, 121) !important;
  background-color: rgb(253 242 248) !important;
}
</style>
